import style_inject_es_default from "../../../../../../node_modules/.pnpm/style-inject@0.3.0/node_modules/style-inject/dist/style-inject.es.js";

//#region src/components/cover/cover.module.css
var css_248z = ".cover-module_root__XU2SD {\n    background: var(--mantine-color-body) !important;\n}\n\n.cover-module_root--no-overflow__Hzvnc {\n    body:has(&) {\n        overflow: hidden;\n    }\n}\n";
var cover_module_default = {
	"root": "cover-module_root__XU2SD",
	"root--no-overflow": "cover-module_root--no-overflow__Hzvnc"
};
style_inject_es_default(css_248z);

//#endregion
export { cover_module_default as default };